{
  "title": "Dice",
  "subtitle": "Predict whether the roll lands above or below the threshold",
  "connecting": "Connecting…",
  "connected": "Connected",
  "reconnecting": "Reconnecting…",
  "unauthorized": "Unauthorized",
  "authFailed": "Login failed",
  "backLobby": "Lobby",
  "lobby": "Lobby",
  "balance": "Balance {{amount}}",
  "target": "Threshold",
  "underWinRate": "Under · ~{{pct}}% win rate",
  "overWinRate": "Over · ~{{pct}}% win rate",
  "bet": "Amount",
  "half": "1/2",
  "max": "Max",
  "under": "Under",
  "over": "Over",
  "chooseSide": "Choose Direction",
  "winChance": "Win Chance",
  "selectedRule": "Prediction",
  "rollChoice": "Roll · {{choice}} {{target}}",
  "rolling": "Rolling…",
  "result": "Result",
  "winPayout": "Won +{{amount}}",
  "loseTag": "No Win",
  "loseAmount": "Lost -{{amount}}",
  "resultAnnouncement": "Result {{roll}}, {{outcome}}",
  "targetMark": "Threshold {{value}}",
  "winLine": "{{choice}} {{target}} · Won {{payout}} · {{odds}}x",
  "loseLine": "{{choice}} {{target}} · Lost · {{odds}}x",
  "betFailed": "Bet failed",
  "quoteUnavailable": "Odds are unavailable. Retry before placing another bet.",
  "quotePendingShort": "Loading",
  "retryQuotes": "Retry odds",
  "balanceStale": "The round completed, but the balance has not synced. Refresh it before betting again.",
  "balanceOutcomeUnknown": "The wager result could not be confirmed. Refresh your balance before placing another bet.",
  "retryBalance": "Refresh balance",
  "refreshingBalance": "Refreshing balance…",
  "retry": "Retry",
  "quickChips": "Quick chips",
  "close": "Close",
  "rules": "Rules",
  "rulesTitle": "How to Play Dice",
  "rulesBody": "Select a threshold between 2 and 98 and choose Under or Over. A random number from 0 to 100 will be rolled. If your prediction is correct, you win based on the dynamic odds.",
  "errors": {
    "insufficient_funds": "Insufficient funds",
    "user_not_found": "User not found",
    "invalid_bet": "Invalid bet amount",
    "invalid_target": "Threshold must be between 2 and 98",
    "invalid_choice": "Invalid choice",
    "unauthorized": "Please log in",
    "play_failed": "Game failed",
    "unknown": "An error occurred"
  }
}
